module.exports = __webpack_public_path__ + "static/media/withdraw-clock@2x.eba03cf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/withdraw-clock@2x.png
// module id = 1035
// module chunks = 0